import {
  checkHasLockPIN,
  updateLockPin,
} from '@akin-home/lock-screen/frontend';
import { useMutation, useQuery, useQueryClient } from 'react-query';

export const useHasLockPIN = ({ user_id }: { user_id?: string }) => {
  const res = useQuery(['has_lock_pin', user_id], () =>
    checkHasLockPIN({ user_id })
  );

  return res;
};

export const useUpdateLockPIN = () => {
  const query_client = useQueryClient();

  return useMutation(updateLockPin, {
    onSuccess(_, vars) {
      query_client.invalidateQueries(['has_lock_pin', vars.user_id]);
    },
  });
};
